import React from "react";
import Navbars from "../Components/navbar";
import Project from "./project";





const Detailslink = () => {
    return(
        <>
        <Navbars />
        <Project />
        </>
    )
}

export default Detailslink;